import React from 'react';
import { HighchartsReactRefObject } from 'highcharts-react-official';

import { CardSkeleton } from '../../../Skeleton';
import usePieData from './usePieData';
import PieView from './PieView';

const PieContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<HighchartsReactRefObject | null>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = usePieData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <CardSkeleton />;
  }

  return (
    <PieView
      chartRef={chartRef}
      options={options!}
      isNoData={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default PieContent;
